// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"modalFooter__c2sC6"};